import { REQUEST_DELETE_MEDIA, RECIEVE_DELETE_MEDIA } from '../constants/actionTypes';
import { getBody, displayError } from './helpers';
import { getBackendUrl } from '../env';


// Action Creators
const requestDeleteMedia = (scene, sceneMediaID) => ({
    type: REQUEST_DELETE_MEDIA,
    scene: scene,
    sceneMediaID: sceneMediaID
});

const recieveDeleteMedia = (scene, sceneMediaID) => ({
    type: RECIEVE_DELETE_MEDIA,
    scene: scene,
    sceneMediaID: sceneMediaID
});

const cleanupDeleteMedia = (scene, sceneMediaID) => ({
    type: RECIEVE_DELETE_MEDIA,
    sceneMediaID: sceneMediaID,
    cleanup: true
});

// Action Logic
const canDeleteMedia = mediaItem => {
    return !mediaItem.deleting;
};

const deleteMedia = (scene, sceneMediaID) => dispatch => {
    dispatch(requestDeleteMedia(scene, sceneMediaID));
    return fetch(`${getBackendUrl()}/api/v1/scene/${scene}/media/${sceneMediaID}`, {method: 'DELETE'})
        .then(getBody)
        .then(json => dispatch(recieveDeleteMedia(scene, json.sceneMediaID)));
};

const tryDeleteItem = (scene, item, dispatch) => {
    if (canDeleteMedia(item)) {
        dispatch(deleteMedia(scene, item.sceneMediaID))
            .catch(err => {
                dispatch(cleanupDeleteMedia);
                dispatch(displayError(err));
            }
        ); 
    }
};

export const deleteSelectedMediaIfOK = scene => (dispatch, getState) => {
    const state = getState();
    const {mediaItems} = state.mediaByScene[scene];

	const selectedMedia = mediaItems.filter(m => m.selected);
	
	let items = selectedMedia.map(i => i.mediaName).join(", ")
	if (!window.confirm("Delete " + selectedMedia.length + " items?\n" + items)) {
		return
	}

    selectedMedia.forEach(selected => tryDeleteItem(scene, selected, dispatch));
};



// WEBPACK FOOTER //
// ./src/actions/deleteMedia.js